import { Button, Stack } from "@mui/material";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

import PaymentStatusBadge from "./PaymentStatusBadge";
import {
  mapOperationalStateToBadge,
  pick,
} from "./paymentGatewayUtils";

const RequestPaymentActionCell = ({ row, paymentSummary, compact = false }) => {
  const navigate = useNavigate();
  const requestId = pick(row, "id", "Id") ?? pick(row, "requestInfoId", "RequestInfoId");

  const summary =
    paymentSummary?.find(
      (p) =>
        Number(pick(p, "requestInfoId", "RequestInfoId")) === Number(requestId)
    ) ?? null;

  if (!summary) {
    return null;
  }

  const operationalState = pick(summary, "operationalState", "OperationalState");
  const title = pick(summary, "operationalStateTitle", "OperationalStateTitle");
  const invoiceId = pick(summary, "primaryInvoiceId", "PrimaryInvoiceId");
  const showPay = pick(summary, "showPayAction", "ShowPayAction");

  const badgeState = mapOperationalStateToBadge(operationalState);

  const goPay = () => {
    if (invoiceId) {
      navigate(`/SLN/Customer/InvoicePayment/${invoiceId}`);
      return;
    }
    navigate(`/SLN/Customer/Requests/Information?id=${requestId}`);
  };

  if (compact) {
    if (showPay && operationalState !== "Paid") {
      return (
        <Button
          size="small"
          variant="outlined"
          sx={{ minWidth: 64, py: 0.25, fontSize: 12 }}
          onClick={(e) => {
            e.stopPropagation();
            goPay();
          }}
        >
          پرداخت
        </Button>
      );
    }
  }

  return (
    <Stack spacing={0.75} alignItems="flex-start" sx={{ minWidth: compact ? 80 : 120 }}>
      {!compact ? <PaymentStatusBadge state={badgeState} label={title} /> : null}
      {showPay && operationalState !== "Paid" ? (
        <Button
          size="small"
          variant={compact ? "outlined" : "contained"}
          fullWidth={!compact}
          sx={{ minHeight: compact ? 28 : 36, fontSize: compact ? 12 : undefined }}
          onClick={(e) => {
            e.stopPropagation();
            goPay();
          }}
        >
          پرداخت
        </Button>
      ) : compact && title ? (
        <PaymentStatusBadge state={badgeState} label={title} />
      ) : null}
    </Stack>
  );
};

RequestPaymentActionCell.propTypes = {
  row: PropTypes.object.isRequired,
  paymentSummary: PropTypes.array,
  compact: PropTypes.bool,
};

export default RequestPaymentActionCell;
